export const enAgentGuiSide = {
  sideCommandDescription:
    "Open a temporary conversation from the current live context",
  sidePanelTitle: "Side conversation",
  sideEmptyTitle: "Side conversation",
  sideEmptyDescription:
    "Side conversations are temporary and disappear when you close the app.",
  sideInputPlaceholder: "Ask a related question",
  sideResize: "Resize Side conversation",
  sideCollapse: "Collapse Side conversation",
  selectionAddToConversation: "Add to conversation",
  selectionAskInSide: "Ask in Side chat",
  selectionReferenceCountOne: "1 selected file snippet",
  selectionReferenceCountMany: "{{count}} selected file snippets",
  sideInteractionTitle: "Side needs your response",
  sideContentUnsupported:
    "This attachment type is not supported in a Side conversation yet.",
  sideOperationFailed:
    "The Side conversation could not complete that operation. Close it and try again."
} as const;
